import { styled } from "@stitches/react";
import React from "react";
import { FlexBox } from "../primitives";

const MarketTypeStyled = styled("button", {
  all: "unset",
  cursor: "pointer",
  width: 120,
  padding: "10px",
  borderRadius: "16px 0 0 16px",
  textAlign: "center",
  variants: {
    isSelected: {
      true: {
        color: "white",
        background: "$primary",
      },
      false: {
        color: "grey",
        background: "white",
      },
    },
    side: {
      right: { borderRadius: "0px 16px 16px 0px" },
      left: {
        borderRadius: "16px 0 0 16px",
      },
    },
  },
});

type MarketType = "cardtrader" | "cardmarket";

interface CardMarketCardTraderSwitchProps {
  selected: MarketType;
  setSelected: (arg1: MarketType) => void;
}

export const CardMarketCardTraderSwitch = ({
  selected,
  setSelected,
}: CardMarketCardTraderSwitchProps) => {
  return (
    <FlexBox css={{ justifyContent: "center" }}>
      <MarketTypeStyled
        tabIndex={0}
        isSelected={selected === "cardtrader"}
        side="left"
        onClick={() => setSelected("cardtrader")}
      >
        CARDTRADER
      </MarketTypeStyled>
      <MarketTypeStyled
        tabIndex={0}
        isSelected={selected === "cardmarket"}
        side="right"
        onClick={() => setSelected("cardmarket")}
      >
        CARDMARKET
      </MarketTypeStyled>
    </FlexBox>
  );
};
